var documentScrolled = false

export default class Block {
    
    constructor(blockRoot) {
        this.root = $(blockRoot)
        
        this.blockid = this.root.data('blockid')
        
        this.initialScroll()
    }
    
    initialScroll() {
        if (documentScrolled) {
            return
        }
        if (this.blockid) {
            var params = window.location.href.match(/[?&]blockid=([^&]+)/)
            var anchor = params && params.length > 0
                         ? params[1]
                         : window.location.hash.replace('#', '')
            
            if (anchor) {
                if (this.blockid.toString() === anchor) {
                    setTimeout(this.scrollTo.bind(this), 200)
                    documentScrolled = true
                }
            }
        }
        return this
    }
    
    scrollTo() {
        $('html, body').animate({
            scrollTop: this.root.offset().top - $('#site-header').find('.site-header__bottom-row').outerHeight(),
        }, 600)
        return this
    }
}
